/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergencyEmailContactOnAzure
 */
export interface EmergencyEmailContactOnAzure {
    /**
     * 
     * @type {string}
     * @memberof EmergencyEmailContactOnAzure
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyEmailContactOnAzure
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyEmailContactOnAzure
     */
    language_code: string;
}

/**
 * Check if a given object implements the EmergencyEmailContactOnAzure interface.
 */
export function instanceOfEmergencyEmailContactOnAzure(value: object): value is EmergencyEmailContactOnAzure {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    return true;
}

export function EmergencyEmailContactOnAzureFromJSON(json: any): EmergencyEmailContactOnAzure {
    return EmergencyEmailContactOnAzureFromJSONTyped(json, false);
}

export function EmergencyEmailContactOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyEmailContactOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'email': json['email'],
        'language_code': json['language_code'],
    };
}

export function EmergencyEmailContactOnAzureToJSON(json: any): EmergencyEmailContactOnAzure {
    return EmergencyEmailContactOnAzureToJSONTyped(json, false);
}

export function EmergencyEmailContactOnAzureToJSONTyped(value?: EmergencyEmailContactOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'language_code': value['language_code'],
    };
}

